export default "__VITE_ASSET__G4a4tb38__"